// removed by extract-text-webpack-plugin
module.exports = {"component":"_2Bk4ni4MjAHteiITnQBzAY","money":"_2riH2CYKSU1gLgg_cysO0E","invoiceSumMoney":"_3zsGREgAaTPjT_PdJOg7og"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProductInvoiceMoneyInfo/ProductInvoiceMoneyInfo.scss
 ** module id = 1018
 ** module chunks = 0
 **/